import React, { useEffect } from "react";
import DetectedPersonTimeline from "./DetectedPersonTimeline";
import { InformationCircleIcon } from "@heroicons/react/outline"; // Pastikan impor ini benar
import { motion, useMotionValue, useTransform } from "motion/react";
import { useSelector } from "react-redux";
import { animate } from "motion";

const Detail = () => {
  const targetIsDpo = useSelector((state) => state.targetIsDpo.data || []);
  const target = useSelector((state) => state.target.data || []);
  const camera = useSelector((state) => state.realtime.selectedCamera);
  const count = useMotionValue(0);
  const rounded = useTransform(() => Math.round(count.get()));
  // console.log(targetIsDpo, 'targetIsDpo')
  // console.log(target, 'target')

  useEffect(() => {
    const controls = animate(count, target?.length + targetIsDpo?.length || 0, {
      duration: 5,
    });
    return () => controls.stop();
  }, [target, targetIsDpo]);

  return (
    <div className="">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-4">
        {/* Detail Informasi Kamera */}
        <div className="col-span-12 lg:col-span-5 text-white  shadow-md rounded-xl">
          <div className="flex items-center gap-2 mb-4">
            <InformationCircleIcon className="h-5 w-5 text-blue-500" />
            <h2 className="text-base sm:text-lg md:text-xl font-semibold">
              Detail Informasi Kamera
            </h2>
          </div>
          <div className="space-y-3 text-sm sm:text-base md:text-lg">
            {/* Organisasi */}
            <div className="flex flex-col sm:flex-row">
              <span className="font-semibold w-full sm:w-1/3">Organisasi</span>
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
                className="font-medium break-words sm:w-2/3"
              >
                : {camera?.organization_name || "N/A"}
              </motion.div>
            </div>

            {/* Operasi */}
            <div className="flex flex-col sm:flex-row">
              <span className="font-semibold w-full sm:w-1/3">Operasi</span>
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
                className="font-medium break-words sm:w-2/3"
              >
                : {camera?.operation_name || "N/A"}
              </motion.div>
            </div>

            {/* Type */}
            <div className="flex flex-col sm:flex-row">
              <span className="font-semibold w-full sm:w-1/3">Type</span>
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
                className="font-medium break-words sm:w-2/3"
              >
                : {camera?.tipe_perangkat || "N/A"}
              </motion.div>
            </div>
          </div>
        </div>

        {/* Timeline Deteksi */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="col-span-12 sm:col-span-2 md:col-span-6 lg:col-span-4   rounded-xl"
        >
          <DetectedPersonTimeline
            target={targetIsDpo?.length || 0}
            people={target?.length || 0}
          />
        </motion.div>

        {/* Total Deteksi */}
        <div className="col-span-12 lg:col-span-3 text-white text-center sm:text-right flex flex-col rounded-xl">
          <h2 className="text-base sm:text-lg md:text-xl font-semibold mb-4">
            Total Deteksi
          </h2>
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold "
          >
            <motion.pre>{rounded}</motion.pre>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Detail;
